module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('CasePlanAndServicesEdition', {
    attrs: {
      "is-in-dialog": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de00938","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AppEditCasesDialog.vue
// module id = 954
// module chunks = 1